import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  refreshButton: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    alignItems: 'center',
  },
  refreshIcon: {
    marginRight: 6,
  },
});
